module.exports = __webpack_public_path__ + "img/login.07f61696.png";